import React from 'react';

function PaymentCancel({ onNavigateToBuyTokens, onNavigateToHome }) {
  return (
    <div style={pageStyle}>
      <section style={panelStyle}>
        <p style={eyebrowStyle}>Checkout cancelled</p>
        <h1 style={headingStyle}>No payment was completed</h1>
        <p style={copyStyle}>
          You left checkout before finishing. Your PromoGrind token balance was not changed,
          and you can return whenever you are ready.
        </p>

        <div style={actionsStyle}>
          <button type="button" onClick={onNavigateToBuyTokens} style={primaryButtonStyle}>
            Review Token Packages
          </button>

          <button type="button" onClick={onNavigateToHome} style={secondaryButtonStyle}>
            Discovery Dashboard
          </button>
        </div>

        <div style={noteStyle}>
          <h2 style={noteHeadingStyle}>Discovery rewards are still staged</h2>
          <p style={noteCopyStyle}>
            Future rewards will come from internal discovery and useful feedback.
            External visits and engagement will never earn PromoGrind tokens.
          </p>
        </div>
      </section>
    </div>
  );
}

const pageStyle = {
  minHeight: 'calc(100vh - 76px)',
  padding: '48px 16px',
  background: 'linear-gradient(180deg, #f8fafc 0%, #eef6f0 100%)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#1f2937'
};

const panelStyle = {
  width: '100%',
  maxWidth: 620,
  backgroundColor: '#ffffff',
  border: '1px solid #dbe4ee',
  borderRadius: 8,
  padding: 30,
  textAlign: 'center',
  boxShadow: '0 18px 42px rgba(15, 23, 42, 0.1)'
};

const eyebrowStyle = {
  margin: '0 0 10px',
  color: '#b45309',
  fontSize: 13,
  fontWeight: 800,
  textTransform: 'uppercase',
  letterSpacing: 0
};

const headingStyle = {
  margin: '0 0 12px',
  color: '#111827',
  fontSize: 32,
  lineHeight: 1.15
};

const copyStyle = {
  margin: '0 auto 24px',
  maxWidth: 500,
  color: '#526070',
  fontSize: 17,
  lineHeight: 1.55
};

const actionsStyle = {
  display: 'flex',
  justifyContent: 'center',
  flexWrap: 'wrap',
  gap: 12
};

const primaryButtonStyle = {
  backgroundColor: '#f59e0b',
  color: '#111827',
  border: 'none',
  borderRadius: 8,
  padding: '13px 20px',
  fontSize: 15,
  fontWeight: 800,
  cursor: 'pointer'
};

const secondaryButtonStyle = {
  backgroundColor: '#ffffff',
  color: '#2563eb',
  border: '1px solid #bfdbfe',
  borderRadius: 8,
  padding: '13px 20px',
  fontSize: 15,
  fontWeight: 800,
  cursor: 'pointer'
};

const noteStyle = {
  marginTop: 26,
  padding: 18,
  backgroundColor: '#f8fafc',
  border: '1px solid #dbe4ee',
  borderRadius: 8,
  textAlign: 'left'
};

const noteHeadingStyle = {
  margin: '0 0 8px',
  color: '#111827',
  fontSize: 18
};

const noteCopyStyle = {
  margin: 0,
  color: '#526070',
  lineHeight: 1.5
};

export default PaymentCancel;
